<template>
  <b-card class="border-none">
    <b-modal
      modal-content-classes="cust-modal-ht"
      header-bg-variant="primary"
      id="edit-review"
      title="Edit Brand"
      hide-footer
      header-text-variant="white"
    >
      <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <b-form role="form" @submit.prevent="handleSubmit(handleUpdate)">
          <div class="mb-4">
            <p class="input-title text-black">
              Heading<span class="clr-red">*</span>
            </p>
            <base-input
              v-model="heading"
              placeholder="Enter review heading"
              class="md:border-0 lg:border-0 custipshadow"
              name="Name"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="mb-4">
            <p class="input-title text-black">
              Description<span class="clr-red">*</span>
            </p>
            <base-input
              v-model="description"
              placeholder="Enter review content"
              class="md:border-0 lg:border-0 custipshadow"
              name="Email"
              :rules="{ required: true }"
            ></base-input>
          </div>
          <div class="flex justify-center">
            <b-button
              class="font-semibold"
              type="primary"
              native-type="submit"
              variant="primary"
              >Save</b-button
            >
          </div>
        </b-form>
      </validation-observer>
    </b-modal>
    <b-input-group class="">
      <b-form-input
        class="border-none shadow-lg"
        type="text"
        min="0.00"
        v-model="search"
        @input="dataLoad"
        placeholder="Enter Search...."
      ></b-form-input>

      <b-input-group-append>
        <b-button
          variant="white"
          class="flex items-center shadow-lg"
          aria-label="search"
          @click="dataLoad()"
        >
          <feather-icon
            class="cursor-pointer mr-2"
            icon="SearchIcon"
            svgClasses="w-4 h-4"
          ></feather-icon>
        </b-button>
      </b-input-group-append>
    </b-input-group>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="ffc_review.result"
      border
    >
      <el-table-column
        label="Heading"
        min-width="250px"
        prop="heading"
        class="ml-12"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.heading }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        label="Description"
        min-width="250px"
        prop="description"
        class="ml-12"
        sortable
      >
        <template v-slot="{ row }">
          <p class="font-semibold text-left name mb-0 text-sm">
            {{ row.description }}
          </p>
        </template>
      </el-table-column>

      <el-table-column
        label="Actions"
        min-width="100px"
        class-name="text-center"
      >
        <template slot-scope="scope">
          <div class="flex justify-center items-center">
            <feather-icon
              icon="EditIcon"
              svgClasses="w-6 text-blue-500 cursor-pointer"
              class="mr-2"
              @click="handleEdit(scope)"
            ></feather-icon>
            <feather-icon
              icon="Trash2Icon"
              svgClasses="w-6 text-red-600 cursor-pointer"
              class="ml-2"
              @click="handleDelete(scope)"
            ></feather-icon>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination
        v-model="currentPage"
        :per-page="perPage"
        :total="totalPages"
        @change="handlePageChange"
      ></base-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import { mapState } from "vuex";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      search: "",
      totalPages: 0,
      heading: "",
      description: "",
      reviewId: "",
    };
  },
  watch: {
    search: {
      handler: _.debounce(async function (val) {
        this.dataLoad();
        this.currentPage = 1;
      }, 500),
    },
  },
  methods: {
    async dataLoad() {
      let payload = {
        search: this.search,
        limit: 10,
        offset: (this.currentPage - 1) * 10,
      };
      let data = await this.$store.dispatch("ffc/get_review", payload);
      this.totalPages = data.data.totalCount;
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.dataLoad();
    },
    async handleEdit(scope) {
      let { row } = scope;
      this.heading = row.heading;
      this.description = row.description;
      this.reviewId = row._id;
      this.$bvModal.show("edit-review");
    },
    async handleUpdate() {
      let payload = {
        heading: this.heading.trim(),
        description: this.description.trim(),
        _id: this.reviewId,
      };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("ffc/update_review", payload);
        this.dataLoad();
        this.$bvModal.hide("edit-review");
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.deleteData(data);
      }
    },
    deleteAlert() {
      return this.$swal({
        title: "Are you sure?",
        html: `<p class="text-center">You won't be able to revert this!</p>`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#830c81",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
    },
    async deleteData({ row }) {
      // console.log(row);
      const payload = { reviewId: row._id };
      let loader = this.$loading();
      try {
        await this.$store.dispatch("ffc/delete_review", payload);
        this.dataLoad();
        loader.close();
      } catch (error) {
        loader.close();
      }
    },
  },
  computed: {
    ...mapState("ffc", {
      ffc_review: "ffc_review",
    }),
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
